// Copyright (c) StrangeBee 2024

import React, { ReactElement, useMemo } from 'react';
import { THButton } from '@Molecules/Inputs/THButton/THButton';
import { useLocalMessage } from '@Helpers/locale';
import { classList } from '@Helpers/className';

import './PreviewButton.scss';

interface PreviewButtonProps {
    onClick?: () => void;
    label?: string;
    block?: boolean;
}

const PreviewButton = ({ onClick, label, block }: PreviewButtonProps): ReactElement => {
    const locale = useLocalMessage();
    const realLabel = useMemo(() => label || locale('common.preview'), [label, locale]);

    return (
        <div className={classList('preview-button', { block })}>
            <THButton block={block} type="default" onClick={onClick}>
                {realLabel}
            </THButton>
        </div>
    );
};

export default PreviewButton;
